/** 资源管理相关Api */

import { _, AppAuthApi, App, defineAppApi } from '@zto/zpage'

import { JSEncrypt } from 'jsencrypt'

import { userData } from './userData'

export const AUTH_PUB_KEY =
  '-----BEGIN PUBLIC KEY-----\n' +
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1urQo4aFS7kIuCsHSnAr\n' +
  'GYftEVoXTBosCQG+sCPDv6owvITvaMy5usPiI5r155iYt/PLqE823nT5OqEgTW6Y\n' +
  '1zhLHWrEkf2TR003+moIoF8st5iOhSZvsGwHOciL5tur9ur0xoXhxukK4YjZliHY\n' +
  'pZVJrV7PPvmjoUbdIr1IjQf8YTXtwGYh4Ic5tEARejSfxDFDSs5V5kcVRoLXCPFt\n' +
  'TResWg2CseO0RoxCM/uBQp4ZTBRbuKDQxUrsX0BfvzL85OaYDSKZeoFNrDkeji6v\n' +
  'GhFjRRD4IMdGuLImhC8IvcsCA9GFcgX3zy55UYLterdwgBSHueSTrwq4psp9DLu/\n' +
  'AQIDAQAB\n' +
  '-----END PUBLIC KEY-----'

const publicKey = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDH2izEULYuGiI0RI7dpdflr9Ny
hT2jtW9okme7o8a6y6VJFxoxSQkNMFVoh8c5eV900CBeohGNu5ZBo9NO0rBnt8OM
IBYlTVF5UdyZf7TpuKGSkwCorBfiSVob8ccwH9BvSr9VCuiDZ6FtZzq+6rAbE3+P
kkNQHgmYDk0v758DjQIDAQAB
-----END PUBLIC KEY-----
`

export enum LoginMode {
  PASSWORD = 1, // 密码登录
  SMS = 2 // 短信登录
}

export interface LoginModel {
  mode: LoginMode
  // username?: string
  password?: string
  mobile: string
  verifyCode?: string
  verifyId?: String
}

function encrypt(data: string, publicKey: string) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return encryptor.encrypt(data)
}

export default defineAppApi<AppAuthApi>((app: App) => {
  const encryptor = new JSEncrypt() // 创建加密对象实例

  return {
    baseUrl: app.env.apiUrl,

    methods: api => {
      return {
        async login(loginModel: LoginModel) {
          const encryptData = loginModel.mobile + ' ' + loginModel.verifyCode
          // debugger
          console.log('====encryptData：', encryptData)
          const rsaCode = encrypt(encryptData, publicKey)
          console.log('====rsaCode：', rsaCode)
          let platformName = 'pc'
          if (window && window.location) {
            if (
              window.location.href.indexOf('ads.tuxi.com') > -1 ||
              window.location.href.indexOf('stg.ztosys.com') > -1
            ) {
              platformName = 'pc'
            }
          }
          // const res = await app.request({
          //   api: 'tuxi.ad.customer.verifyCodeLogin',
          //   params: { platformName: platformName, authorization: rsaCode }
          // })
          // console.log('====doLogin:', JSON.stringify(res))

          /** 保存accessToken */
          // app.token.setAccessToken([res.accessToken].join())
          app.token.setAccessToken('wwwwwxxx')
        },

        /** 发送验证码 */
        async sendVerifyCode(loginModel: any) {
          const res = await app.request({
            // url: app.env.ssoUrl + '/oauth2/sending-verify-code?mobile_phone=' + mobile
            api: 'twt.courier.sendVerifyCode',
            data: {
              phone: loginModel.mobile,
              verifyId: loginModel.verifyId,
              action: 'login'
            }
          })
          console.log('res sendVerifyCode', res)
          return
        },

        /** 获取用户信息 */
        async getUserInfo() {
          // debugger
          // const res: any = await api.request({
          //   url: 'base.getCurrentUserInfo'
          // })

          let res = {
            realName:'张三',
            mobile:'15021322321',
            pcMenuTree:[],
            pcPermissionValues: [],
            adminFlag: true
          }

          const [accessToken, userId, openid] = (app.token.getAccessToken() || '').split(',')

          const basicInfo = {
            ...res,
            userId,
            openid,
            nickname: res.realName || '匿名',
            username: res.realName,
            mobile: res.mobile
          }

          // const pcMenuTree = [
          //   {
          //     code: 'P1676603579653',
          //     name: '经营管理',
          //     type: 'MENU',
          //     icon: '',
          //     url: '',
          //     sort: '10',
          //     parentCode: '0',
          //     value: 'boss.pc',
          //     // children: [...(res.pcMenuTree || [])]
          //     children: res?.pcMenuTree?.[0]?.children || []
          //   }
          // ]
          const pcMenuTree = res?.pcMenuTree.filter((item: any) => item.value === 'kt.ztsale')
          // pcMenuTree.length && (pcMenuTree[0].value = 'boss.pc')

          /** 用户菜单信息 */
          const menus = pcMenuTree
            .map((it: any) => formatScmMenu(it))
            .sort(menuOrder)
            .filter((it: any) => it.path !== '/welcome') // 过滤welcome页面（特殊）永远不会出现在菜单中！！！

          return {
            ...basicInfo,
            menus,
            permissions: res.pcPermissionValues,
            data: {
              userid: userId,
              openid,
              adminFlag: basicInfo.adminFlag,
              basic: basicInfo
            }
          }
        },

        /** 获取用户岗位 */
        async getUserPositions() {
          return []
        },

        /**
         * 检查用户权限
         * @param code 权限编码
         */
        checkPermission(codes: string | string[]) {
          if (!codes) return true

          codes = Array.isArray(codes) ? codes : [codes]

          const permissions = app.stores.userStore.permissions || []

          const flag = codes.some(code => permissions.includes(code))
          return flag
        }
      }
    }
  }
})

function formatScmMenu(scmMenu: any) {
  const order = parseInt(scmMenu.sort)

  const menu: any = {
    menuId: scmMenu.code,
    parentMenuId: scmMenu.parentCode,
    keyName: scmMenu.value,
    menuName: scmMenu.name,
    name: scmMenu.name,
    path: scmMenu.url,
    order: isNaN(order) ? 0 : order
  }

  if (scmMenu.children?.length) {
    menu.children = scmMenu.children
      .map((it: any) => {
        return formatScmMenu(it)
      })
      .sort(menuOrder)
  }

  return menu
}

function menuOrder(a: any, b: any) {
  return a?.order - b?.order
}
